export default "__VITE_ASSET__CJT8sNSJ__"